import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";

export class Restaurant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  render () {
    return (
      <div class="main">
        <Helmet>
          <title>Бронирование столиков в ресторане | Система для кафе — Planna</title>
          <meta name="description" content="Визуальная схема зала с выбором конкретного столика. Гости бронируют сами, вы видите загрузку в реальном времени. Бесплатно для ресторанов и кафе." />
        </Helmet>
        <h1 class="main2">Управляйте бронированием столиков визуально — как на бумажной схеме, но удобнее</h1>
        <h2 class="main2">Вы видите реальную картину зала в реальном времени</h2>
        <div class="main3">Как это работает:</div>
        <div class="main3">Вы загружаете схему вашего зала и выделяете столики на схеме</div>
        <div class="w40">
          <ul class="main3">
            <li>Свободен</li>
            <li>Забронирован</li>
            <li>Выбран для бронирования</li>
          </ul>
        </div>
        <div class="w40 main3">
        Что видит сотрудник:
        </div>

        <div class="w40 main3">
        На схеме зала сразу видно, какие столики свободны, где скоро освободится место, а где — большая компания на юбилей. Никаких переключений между списками и таблицами
        </div>

        <div class="w40 main3">
        Что видит клиент при онлайн-бронировании:
        </div>

        <div class="w40">
          <ul class="main3">
            <li>Выбирает дату и время</li>
            <li>Видит схему зала с доступными столиками</li>
            <li>Может отфильтровать столы (у окна, в тихой зоне, у сцены, количество гостей)</li>
            <li>Может выбрать конкретный стол</li>
          </ul>
        </div>

        <div class="w40 main3">
        Дополнительные возможности
        </div>

        <div class="w40">
          <ul class="main3">
            <li>Разные зоны зала (VIP, терраса, бар) с разными условиями бронирования</li>
            <li>Минимальная сумма или депозит для определённых столиков</li>
            <li>Специальные отметки (доступно для инвалидов, детский стульчик)</li>
            <li>Автоматическое предложение ближайших свободных столов под нужное количество гостей</li>
          </ul>
        </div>

        <div class="w40 main3">
        При создании брони вы сразу видите схему зала. Можете назначить конкретный стол или оставить на усмотрение хостес — система подберёт оптимальный вариант. А если гость звонит и просит "тот же столик, что в прошлый раз", вы находите его в один клик по истории
        </div>

        <div class="w40 main3">
        Преимущества:
        </div>
        <div class="main3 w40"><table style={{textAlign: "left"}} class="table table-striped">
          <thead><tr><th>Для ресторана</th><th>Для клиента</th></tr></thead>
          <tbody>
            <tr>
            <td>Максимальное использование площади зала</td><td>Выбор любимого столика</td>
            </tr><tr>
            <td>Никаких накладок с двойными бронями</td><td>Уверенность, что стол ждёт именно их</td>
            </tr><tr>
            <td>Быстрая посадка гостей без очереди</td><td>Прозрачность — видят, какие столики свободны</td>
            </tr><tr>
            <td>Аналитика загрузки по зонам и времени</td><td>Возможность забронировать под мероприятие</td>
            </tr>
          </tbody></table>

        </div>

        <h2 class="main2">Как это работает за 5 минут</h2>
        <p class="main3">
          <div class="nowrap">{this.state.isAuthenticated ? <><span class="btndone">Зарегистрироваться</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Зарегистрировать бизнес бесплатно</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить услуги</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configservices">Добавить услуги</a>}<div class="arrowright"></div></div>
          <div class="nowrap">{this.state.companies.length > 0 ? <><span class="btndone">Добавить русурсы</span><span class="btndone2">✓</span></> : <a style={{marginLeft: "5px"}} class="btn btn-primary" href="configresources">Добавить русурсы (столики)</a>}<div class="arrowright"></div></div>
          <div class="nowrap"><a style={{marginLeft: "5px"}} class="btn btn-primary" href="configqrcode">Распечатать QR-код со ссылкой для клиентов</a><div class="arrowright"></div></div>
          <a style={{marginLeft: "5px"}} class="btn btn-primary" href={this.state.companies.length > 0 ? `booking/${this.state.companies[0].id}` : "booking"}>Начать записывать клиентов</a>
        </p>
      </div>
    );
  }
}
